import { RouteObject } from "react-router";

import { PortalPage } from "@layouts/PortalPage/PortalPage.layout";

import { routes } from "@pages/routes";

import { Notifications } from "./Notifications/Notifications.page";
import { NotificationRules } from "./NotificationRules/NotificationRules.page";
import { NotificationsLayout } from "./NotificationsLayout/NotificationsLayout";

export const notificationsRoutes = [
  {
    path: routes.portal.notifications.$path(),
    Component: PortalPage,
    children: [
      {
        path: "",
        Component: NotificationsLayout,
        children: [
          {
            index: true,
            Component: Notifications,
            handle: {
              fullBleed: true,
              breadcrumb: {
                title: "Notifications",
              },
            },
          },
          {
            path: routes.portal.notifications.rules.$path(),
            Component: NotificationRules,
            handle: {
              fullBleed: true,
              breadcrumb: {
                title: "Rules",
              },
            },
          },
        ],
      },
    ],
  },
] satisfies RouteObject[];
